// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"deb63522","703":"ffb725ce","787":"4c80f2d7"}[chunkId] + ".chunk.js";
};